<i18n>
{
  "ja": {
    "btn": {
      "zoomIn": "画像を拡大",
      "pagetop": "ページ上部に戻る"
    }
  }
}
</i18n>
<template>
  <div v-if="item" class="mb-12 md:mb-8">
    <span ref="state" class="absolute pointer-events-none opacity-0 hidden md:block" />
    <div v-if="item.lead" class="md text-center w-7/8 mx-auto mb-10 md:mb-8" v-html="$md.render(item.lead)" />
    <ul class="px-3 md:p-0">
      <li v-for="(content, index) in items" :key="index" class="max-w-940 mx-auto fade-in block">
        <div v-if="content" class="rounded-xl bg-white md:shadow-box2 p-6 pt-12 md:pt-8 md:pb-6 md:pl-12 md:pr-8">
          <p class="md:text-lg mb-3 md:mb-8 text-center md:text-left">
            <span class="text-38p md:text-40p text-secondary font-bold mr-2 block mx-auto mb-2 md:mr-4 md:m-0 md:inline leading-none">{{ zp(index + 1, 2) }}</span>{{ content.sub }}
          </p>
          <div class="md:flex flex-row-reverse">
            <div v-if="content.image" class="md:w-1/2 md:pl-6 md:-mt-12 text-center">
              <button class="group text-secondary font-semibold" @click.prevent="onModalImage(index)">
                <img :src="$options.filters.cmsURL(content.image.url)" alt="" class="mb-3">
                <span class="leading-none text-xs hidden md:inline-flex items-center py-1 pl-2 pr-3 rounded-full border border-solid border-secondary group-hover:bg-secondary group-hover:text-white">
                  <i class="material-icons leading-none">zoom_in</i>
                  {{ $t("btn.zoomIn") }}
                </span>
              </button>
            </div>
            <div class="md:w-1/2">
              <component v-if="content.title" :is="`h${Number(headLevel)}`" class="text-22p md:text-26p md:mb-8 font-semibold whitespace-pre-wrap">{{ content.title }}</component>
              <div v-if="content.details" class="md mt-3" v-html="$md.render(content.details)" />
            </div>
          </div>
        </div>
        <div v-if="!isContentsLast(index)" class="text-center md:text-left mx-auto md:ml-12 -mb-2">
          <span class="material-icons font-semibold text-gray-500 text-4xl">south</span>
        </div>
      </li>
    </ul>
    <div class="text-center mt-10 md:mt-16 w-7/8 mx-auto">
      <a href="#__layout" v-scroll-to="'#__layout'" class="rounded-full bg-secondary text-white inline-flex items-center justify-center w-7/8 max-w-xs py-4 px-6 md:px-4">{{ $t("btn.pagetop") }}</a>
    </div>
    <modal :show="isShowModal" @close="onClose">
      <img v-if="isShowModal" :src="$options.filters.cmsURL(items[showModalIndex].image.url)" alt="" />
    </modal>
  </div>
</template>

<style lang="sass" scoped>
@import '~assets/css/markdown.sass'
</style>

<script>
import modal from '@/components/modal';
export default {
  components: { modal },
  props: {
    item: {
      type: Object,
      default: () => {},
      require: true
    },
    headLevel: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      showModalIndex: null
    }
  },
  computed: {
    items() {
      return this.item.contents || []
    },
    isShowModal() {
      return this.showModalIndex !== null && parseInt(this.showModalIndex) > -1
    }
  },
  methods: {
    isSP() {
      const styles = getComputedStyle(this.$refs.state)
      return styles.display === 'none'
    },
    isContentsLast(index) {
      const { items } = this
      return items && index >= items.length - 1
    },
    onModalImage(index) {
      !this.isSP() && (this.showModalIndex = index)
    },
    onClose() {
      this.showModalIndex = null
    },
    zp(num, len) {
      return ( Array(len).join('0') + num ).slice( -len )
    },
    onIntersect(entries) {
      const target = entries.target;
      if (entries.isIntersecting) {
        target.classList && target.classList.add
          ? target.classList.add("visible")
          : (target.className += " visible");
      }
    }
  },
}
</script>